import DataBaseDashboardRoutes from './DataBaseDashboardRoutes';

export default DataBaseDashboardRoutes;
